export default __webpack_public_path__ + "static/media/ic_cancel.8fc93081.svg";